import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
import io from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

axios.defaults.withCredentials = true;
const TicketDetail = () => { 
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [responses, setResponses] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [socket, setSocket] = useState(null);
  const navigate = useNavigate();

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [responses]);

  useEffect(() => {
    const socketConnection = io("", {});
    setSocket(socketConnection);
    socketConnection.on("connect", () => {});
  }, []);

  useEffect(() => {
    axios
      .get(`/api/ticket/${id}`)
      .then((res) =>
        setTicket(Array.isArray(res.data) ? res.data[0] : res.data)
      )
      .catch((err) => {
        if (err?.response?.status === 403) {
          alert("คุณไม่มีสิทธิ์เข้าถึง ticket นี้");
          navigate("/tickets");
          return;
        }
        setTicket(null);
        console.error("Error fetching ticket:", err);
      });
  }, [id, navigate]);

  useEffect(() => {
    if (!ticket) return;
    axios
      .get(`/customer/${ticket.customer_id}`)
      .then((res) => setUserDetails(res.data.user))
      .catch(() => setUserDetails(null));
    axios
      .get(`/ticketadmin/message`, {
        params: { ticketNumber: id },
      })
      .then((res) => setResponses(res.data || []))
      .catch((err) => {
        if (err?.response?.status === 403) {
          alert("คุณไม่มีสิทธิ์เข้าถึงบทสนทนาของ ticket นี้");
          navigate("/tickets");
          return;
        }
        console.error("Error fetching messages:", err);
      });
  }, [id, ticket, navigate]);

  useEffect(() => {
    if (socket) {
      socket.on("ticketResponse", (messageData) => {
        setResponses((prev) => {
          const exists = prev.some((msg) => msg.id === messageData.id);
          if (exists) return prev;
          return [...prev, messageData];
        });
      });
    }

    return () => {
      if (socket) {
        socket.off("ticketResponse");
      }
    };
  }, [socket]);

  useEffect(() => {
    if (socket && ticket?.id) {
      socket.emit("joinTicket", { ticketNumber: ticket.id });

      return () => {
        socket.emit("leaveTicket", { ticketNumber: ticket.id });
      };
    }
  }, [socket, ticket?.id]);

  const formatDate = (input) => {
    if (!input) return "N/A";
    const date = new Date(input);
    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    const max = 100 * 1024 * 1024;
    const tooBig = files.find((f) => f.size > max);
    if (tooBig) {
      alert(`File "${tooBig.name}" exceeds 100MB`);
      event.target.value = null;
      setSelectedFiles([]);
      return;
    }
    setSelectedFiles(files);
  };

  const uploadFiles = async () => {
    if (!selectedFiles || selectedFiles.length === 0) return [];
    const names = [];
    try {
      setIsUploading(true);
      for (const f of selectedFiles) {
        const formData = new FormData();
        formData.append("file", f);
        const res = await axios.post(
          `/fileuploads/upload`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (res?.data?.filename) names.push(res.data.filename);
      }
    } catch (err) {
      alert("Failed to upload file(s)");
      return [];
    } finally {
      setIsUploading(false);
    }
    return names;
  };

  const handleSendMessage = async () => {
    if ((!newMessage.trim() && selectedFiles.length === 0) || !ticket) return;

    const fileNames = await uploadFiles();

    const now = new Date(new Date().getTime() + 7 * 60 * 60 * 1000);
    const formattedDate = now.toISOString().slice(0, 19).replace("T", " ");

    const messageData = {
      customer_id: ticket.customer_id,
      ticket_id: ticket.id,
      message: newMessage.trim(),
      created_at: formattedDate,
      AttachFiles: fileNames,
    };

    try {
      socket.emit("sendMessage", messageData);
      setNewMessage("");
      setSelectedFiles([]);
      const el = document.getElementById("file-upload");
      if (el) el.value = "";
    } catch (err) {
      console.error("Send error:", err);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="ticket-detail-page">
      <button
        onClick={() => navigate("/tickets")}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          margin: 0,
          cursor: "pointer",
          width: "auto",
          height: "auto",
        }}
      >
        <BsArrowLeft size={25} />
      </button>

      <h2>Ticket #{id}</h2>
      <div
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "4px",
          backgroundColor: "#fafafa",
          maxWidth: "1500px",
        }}
      >
        <div
          className="ticket-info-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "auto auto",
            gap: "25px",
            alignItems: "center",
          }}
        >
          <h3>Report: {ticket?.issue_summary}</h3>

          <p style={{ margin: 0 }}>
            <strong>User:</strong> {ticket?.name|| "-"}
          </p>
          <p style={{ margin: 0 }}>
            <strong>Created At:</strong> {formatDate(ticket?.created_at)}
          </p>
          <p style={{ margin: 0, textAlign: "left" }}>
            <strong>Help Topic:</strong> {ticket?.help_topic || "-"}
          </p>

          <p style={{ margin: 0 }}>
            <strong>Email:</strong> {ticket?.email || "-"}
          </p>
          <p style={{ margin: 0, textAlign: "left" }}>
            <strong>Status:</strong> {ticket?.status || "-"}
          </p>
        </div>
      </div>

      <h3>Conversation:</h3>
      <div className="chat-messages">
        {responses.map((res) => {
          const isCustomer =
            res.employee_id === null || res.employee_id === undefined;
          const isAdmin = res.employee_id !== null && res.senderId !== null;

          if (!isCustomer && !isAdmin) return null;

          return (
            <div
              key={res.id}
              className={`chat-message ${
                isCustomer ? "cus-message" : "admin-message2"
              }`}
            >
              <div className="message-text">{res.Message}</div>
              {res.AttachFiles && (
                <div className="attachment">
                  {(() => {
                    let files = [];
                    if (Array.isArray(res.AttachFiles)) {
                      files = res.AttachFiles.map((s) =>
                        String(s || "").trim()
                      ).filter(Boolean);
                    } else if (typeof res.AttachFiles === "string") {
                      files = res.AttachFiles.split(",")
                        .map((s) => s.trim())
                        .filter(Boolean);
                    }

                    if (files.length === 0) return null;

                    return (
                      <ul
                        style={{
                          padding: 0,
                          margin: 0,
                          listStyle: "none",
                        }}
                      >
                        {files.map((fname, idx) => (
                          <li
                            key={idx}
                            style={{ margin: "2px 0", lineHeight: 1.2 }}
                          >
                            <a
                              href={`/fileuploads/${encodeURIComponent(
                                fname
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                textDecoration: "none",
                              }}
                            >
                              📄 {fname}
                            </a>
                          </li>
                        ))}
                      </ul>
                    );
                  })()}
                </div>
              )}

              <div className="message-meta">
                <span>
                  {isCustomer
                    ? `From: ${userDetails?.name || "Customer"}`
                    : `From: Admin (${res.senderName || "Unknown"})`}
                </span>
                <span>{formatDate(res?.created_at)}</span>
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input-container">
        <textarea
          className="chat-input"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message here..."
          rows="4"
          style={{ whiteSpace: "pre-wrap" }}
        />
        <div className="chat-actions">
          <input
            type="file"
            id="file-upload"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <label htmlFor="file-upload" className="file-upload-button">
            {selectedFiles.length > 0
              ? `📎 ${selectedFiles.length} file(s)`
              : "📎 Attach File"}
          </label>
          <button
            className="chat-send-button"
            onClick={handleSendMessage}
            disabled={isUploading || (!newMessage.trim() && !selectedFiles)}
          >
            {isUploading ? "Uploading..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketDetail;
